<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormBlogCategory
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          :data="blogCategory"
          :isNew="!id"
          @submit="formBlogCategorySubmit"
          @delete-blog-category="deleteBlogCategory"
          :language="language"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmBlogCategoryRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import FormBlogCategory from './form'
import blogCategoryQuery from '@/services/gql/types/BlogCategory/queries/blogCategory.gql'
import updateBlogCategory from '@/services/gql/types/BlogCategory/mutations/updateBlogCategory.gql'
import createBlogCategory from '@/services/gql/types/BlogCategory/mutations/createBlogCategory.gql'
import deleteBlogCategory from '@/services/gql/types/BlogCategory/mutations/deleteBlogCategory.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'PageBlogCategory',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    FormBlogCategory,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать категорию блога' : 'Создать категорию блога'
    }
  },
  computed: {
    isMutationLoading () {
      return (
        this.$async.createBlogCategory.$pending ||
        this.$async.updateBlogCategory.$pending
      )
    },
    isFormLoading () {
      return this.$apollo.queries.blogCategory.loading
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      blogCategory: null
    }
  },
  methods: {
    formBlogCategorySubmit (blogCategoryPayload) {
      if (this.id) this.updateCategoryBlog(blogCategoryPayload)
      else this.createBlogCategory(blogCategoryPayload)
    },
    async deleteBlogCategory () {
      try {
        await this.$refs.confirmBlogCategoryRemoving.open()
        await this.$async.deleteBlogCategory.$perform({ id: this.id })
        this.$successMsg('Категория блога удалена')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении категории блога с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-blog-categories' })
      }
    },

    async createBlogCategory (data) {
      try {
        delete data.translations
        await this.$async.createBlogCategory.$perform({
          data
        })
        this.$successMsg('Категория блога создана')
        await this.$router.push({ name: 'page-blog-categories' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании категории блога')
      }
    },
    async updateCategoryBlog (data) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateBlogCategory.$perform({
          id: Number(this.id),
          data
        }, { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) })
        this.$successMsg('Категория блога обновлена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении категории блога')
      }
    }
  },
  apollo: {
    blogCategory: {
      fetchPolicy: 'network-only',
      query: blogCategoryQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () { return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } } },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-blog-categories' })
        }
      }
    }
  },
  async: {
    deleteBlogCategory (variables) {
      return this.$apollo.mutate({
        mutation: deleteBlogCategory,
        variables
      })
    },
    createBlogCategory (variables) {
      return this.$apollo.mutate({
        mutation: createBlogCategory,
        variables
      })
    },
    updateBlogCategory (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateBlogCategory,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
